import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Something_went_wrong } from '@root/app.constant';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandler {
  constructor(private toastr: ToastrService) {}

  public handleError(data: any) {
    switch (data.status) {
      case -100:
        this.toastr.error(data.message);
        break;

      case -1:
        switch(data.error.errorCode){
          case -105:
            this.toastr.error(data.error.errorMessage);
            break;
          case -2153:
           this.toastr.error(data.error.errorMessage);
           break;
          case -2154:
           this.toastr.error(data.error.errorMessage);
           break;
          case -21555:
           this.toastr.error(data.error.errorMessage);
           break;
          case -2158:
            this.toastr.error(data.error.errorMessage);
            break; 
          case -2152:
            this.toastr.error(data.error.errorMessage);
            break;
          case -204:
           this.toastr.error(data.error.errorMessage);
           break;
          default:
            this.toastr.error(Something_went_wrong);
            break;
        }
        break;
      default:
        if (data.error) {
          this.toastr.error(data.error.errorMessage);
        }
        break;
    }
  }
}
